import {ExcludeFrom} from "../excludeFrom"

export class SecondaryNav {
    public id = ""
    public title = ""
    public target = ""
    public viewType = ""
    public realm = ""
    public territory = ""
    public language = ""
    public items: Tab[] = [new Tab()]
    public banner: Banner | null = new Banner()
    /**
     * Indicates the A/B Testing value.
     * Note: For variant A defaults to null
     */
    public testingVariant: string | null = null
    public englishTitle: string | null | undefined = undefined

    /**
     * Ctor allowing to use properties' default values when casting from object.
     * Eg: <SecondaryNav>{a: "foo"} should contain all SecondaryNav properties
     * @param self properties to pass
     */
    constructor(self: Partial<SecondaryNav> = {}) {
        Object.assign(this, self)
    }
}
export class Banner {
    imageUrl = ""
    target = ""
}

export class LowerFullWidthContainer {
    public excludeFrom?: ExcludeFrom
    public type = ""
    public title = ""
    public categoryLink?: PersonalizedCategoryLink | null
}

export class PersonalizedCategoryLink {
    public excludeFrom?: ExcludeFrom
    public type = ""
    public title = ""
    public englishTitle = ""
    public target = ""
}

export class Tab {
    public title = ""
    public englishTitle: string | null | undefined = undefined
    public type = ""
    public items: Column[] = [new Column()]
    public missions: Mission | null = null
    public excludeFrom?: ExcludeFrom
}
export class Column {
    public title: string | null = ""
    public englishTitle: string | null | undefined = undefined
    public type: string | null = ""
    public items: Category[] = [new Category()]
    public excludeFrom?: ExcludeFrom
}
export class Category {
    public items: Link[] = [new Link()]
    public icons?: Icons[] = []
    public title: string | null = ""
    public englishTitle: string | null | undefined = undefined
    public type = ""
    public linkColour = ""
    public fontWeight = ""
    public excludeFrom?: ExcludeFrom
}
export class Link {
    public target = ""
    public title = ""
    public englishTitle: string | null | undefined = undefined
    public icons?: Icons[] = []
    public type = ""
    public linkColour = ""
    public fontWeight = ""
    public excludeFrom?: ExcludeFrom
    public icon? = ""
    public originalLinkType = ""
}
export class Mission {
    public noOfColumns = 0
    public title: string | null = ""
    public items: MissionCard[] = [new MissionCard()]
    public categoryLink: CategoryLink | null = new CategoryLink()
    public excludeFrom?: ExcludeFrom
}
export class MissionCard {
    public title = ""
    public imageUrl = ""
    public target: string | null = ""
    public excludeFrom?: ExcludeFrom
}
export class CategoryLink {
    public title = ""
    public target = ""
}
export class DefaultConfig {
    public version = ""
    public country = ""
}
export class Icons {
    public height = 0
    public url = ""
    public width = 0
}
export class PersonalizationChip {
    public title = ""
    public target = ""
}
export class DefaultContentItem {
    public type = ""
    public items: PersonalizationChip[] = []
    public title: string | null = ""
}
export class PersonalizationItemRule {
    public masId = ""
    public items: DefaultContentItem[] = []
    public excludeFrom?: ExcludeFrom
}
export class PersonalizationItems {
    public type = ""
    public rules: PersonalizationItemRule[] = []
    public defaultContent: DefaultContentItem[] = []
}

export class FullWidthContainer {
    public type = ""
    public title = ""
    public personalizationItems: PersonalizationItems[] = []
    public excludeFrom?: ExcludeFrom
}

export class Content {
    public items: PersonalizationChip[] = []
    public row = 0
    public title = ""
}

export class PersonalisedSecondaryNav {
    public excludeFrom?: ExcludeFrom
    public title: string | null = ""
    public englishTitle: string | null | undefined = undefined
    public type = ""
    public items: PersonalisedContent[] = []
}

export class PersonalisedContent {
    public type = ""
    public rules: PersonalisedSecondaryNavRule[] = []
    public defaultContent: Category[] = []
}

export class PersonalisedSecondaryNavRule {
    public masId = ""
    public items: Category[] = []
    public excludeFrom?: ExcludeFrom
}
